import React, { useState, useEffect, useCallback } from 'react';
import { yonetim } from '../api';
import { ONAY_DURUMU, tarih, tarihSaat } from '../yardimcilar';
import DurumEtiketi from '../components/DurumEtiketi';
import Gorsel from '../components/Gorsel';
import OnayModal from '../components/OnayModal';
import Modal from '../components/Modal';

const SEKMELER = [
  { durum: ONAY_DURUMU.BEKLIYOR, ad: 'Bekleyen' },
  { durum: ONAY_DURUMU.ONAYLANDI, ad: 'Onaylı' },
  { durum: ONAY_DURUMU.REDDEDILDI, ad: 'Reddedilen' },
];

export default function Reklamlar({ onDegisim }) {
  const [sekme, setSekme] = useState(ONAY_DURUMU.BEKLIYOR);
  const [kayitlar, setKayitlar] = useState([]);
  const [imlec, setImlec] = useState(null);
  const [dahaVar, setDahaVar] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [karar, setKarar] = useState(null);
  const [onizleme, setOnizleme] = useState(null);

  const yukle = useCallback(async (durum, mevcutImlec) => {
    setHata('');
    setYukleniyor(true);
    try {
      const d = await yonetim.reklamlar(durum, mevcutImlec);
      setKayitlar((o) => (mevcutImlec ? [...o, ...d.kayitlar] : d.kayitlar));
      setImlec(d.sonrakiImlec);
      setDahaVar(!!d.sonrakiImlec);
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => {
    setKayitlar([]);
    setImlec(null);
    yukle(sekme, null);
  }, [sekme, yukle]);

  async function kararVer(onayla, redNedeni) {
    await yonetim.reklamKarar(karar.id, onayla, redNedeni);
    setKarar(null);
    setKayitlar([]);
    yukle(sekme, null);
    onDegisim && onDegisim();
  }

  return (
    <div>
      <div className="page-header">
        <h1>Reklam Onayları</h1>
        <p>Yüklenen reklam görsellerini inceleyin ve karar verin</p>
      </div>

      <div className="tabs">
        {SEKMELER.map((s) => (
          <button key={s.durum} className={`tab${sekme === s.durum ? ' active' : ''}`} onClick={() => setSekme(s.durum)}>
            {s.ad}
          </button>
        ))}
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}

      <div className="card tablo-kart">
        <table>
          <thead>
            <tr>
              <th>Görsel</th>
              <th>Kuyumcu</th>
              <th>Bitiş</th>
              <th>Oluşturma</th>
              <th>Durum</th>
              <th style={{ textAlign: 'right' }}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {kayitlar.map((r) => (
              <tr key={r.id}>
                <td>
                  <Gorsel url={r.gorselUrl} className="logo-kucuk" alt="reklam" />
                </td>
                <td>{r.kuyumcuAdi}</td>
                <td>{tarih(r.bitisTarihi)}</td>
                <td>{tarihSaat(r.olusturmaUtc)}</td>
                <td><DurumEtiketi durum={r.onayDurumu} ad={r.onayDurumuAdi} /></td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button className="btn btn-blue btn-sm" onClick={() => setOnizleme(r)}>İncele</button>
                  {Number(r.onayDurumu) === ONAY_DURUMU.BEKLIYOR && (
                    <button className="btn btn-primary btn-sm" style={{ marginLeft: 6 }} onClick={() => setKarar(r)}>Karar ver</button>
                  )}
                </td>
              </tr>
            ))}
            {!yukleniyor && kayitlar.length === 0 && <tr><td colSpan={6} className="bos">Bu durumda reklam bulunmuyor.</td></tr>}
            {yukleniyor && kayitlar.length === 0 && <tr><td colSpan={6} className="yukleniyor">Yükleniyor…</td></tr>}
          </tbody>
        </table>
      </div>

      {dahaVar && (
        <div style={{ textAlign: 'center' }}>
          <button className="btn btn-gray" disabled={yukleniyor} onClick={() => yukle(sekme, imlec)}>
            {yukleniyor ? 'Yükleniyor…' : 'Daha fazla yükle'}
          </button>
        </div>
      )}

      {onizleme && (
        <Modal baslik="Reklam görseli" onKapat={() => setOnizleme(null)}>
          <Gorsel url={onizleme.gorselUrl} className="gorsel-onizleme" alt="reklam" yerTutucu="Görsel yok" />
          <div className="detay-grid" style={{ marginTop: 14 }}>
            <div className="etiket">Kuyumcu</div><div className="deger">{onizleme.kuyumcuAdi}</div>
            <div className="etiket">Bitiş tarihi</div><div className="deger">{tarih(onizleme.bitisTarihi)}</div>
          </div>
        </Modal>
      )}

      {karar && (
        <OnayModal
          baslik={`Reklam kararı — ${karar.kuyumcuAdi}`}
          aciklama="Onaylanan reklam yayına girer. Reddederseniz gerekçe girmelisiniz."
          onKarar={kararVer}
          onKapat={() => setKarar(null)}
        />
      )}
    </div>
  );
}
